export default __webpack_public_path__ + "static/media/Mr and Ms Elan.cf9785cc.jpg";